import { Icon20LaptopOutline, Icon24DocumentPlusOutline, Icon24FolderSimplePlusOutline } from '@vkontakte/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { CloudIcon } from 'reactApp/ui/VKUIIcons';

export const useUploadButtons = ({ onFolderClick, onFileClick, onSelectFromCloud }) => {
    const storage = useSelector(getCurrentStorage);

    const UPLOAD_OPTIONS = {
        selectFromCloud: {
            id: 'selectFromCloud',
            text: 'Выбрать из Облака',
            icon: <CloudIcon width="20" height="20" />,
            onClick: onSelectFromCloud,
            isWide: true,
        },
        uploadFolder: {
            id: 'uploadFolder',
            text: 'Загрузить папку',
            icon: <Icon24FolderSimplePlusOutline />,
            onClick: onFolderClick,
            isWide: false,
        },
        uploadFiles: {
            id: 'uploadFiles',
            text: 'Загрузить файлы',
            icon: <Icon24DocumentPlusOutline />,
            onClick: onFileClick,
            isWide: false,
        },
        uploadFilesToAlbum: {
            id: 'uploadFiles',
            text: 'Загрузить с компьютера',
            icon: <Icon20LaptopOutline />,
            onClick: onFileClick,
            isWide: true,
        },
    };

    if (storage === EStorageType.albums || storage === EStorageType.vigbo) {
        return [UPLOAD_OPTIONS.uploadFilesToAlbum, UPLOAD_OPTIONS.selectFromCloud];
    }

    if (storage === EStorageType.alldocuments || storage === EStorageType.incomingPublic) {
        return [UPLOAD_OPTIONS.uploadFiles];
    }
    return [UPLOAD_OPTIONS.uploadFolder, UPLOAD_OPTIONS.uploadFiles];
};
